import defaults from '../../translations/en.json';

export const levelOfCaresMapping: any = {
  ROUTINE: 'Routine Home Care',
  CONTINUOUS_CARE: 'Continuous Care',
  GENERAL_IN_PATIENT: 'General Inpatient',
  RESPITE: 'Respite Care',
};
export const lOCShortMapping: any = {
  ROUTINE: 'RTN',
  CONTINUOUS_CARE: 'CC',
  GENERAL_IN_PATIENT: 'GIP',
  RESPITE: 'RSP',
};
export const lOCLongMapping: any = {
  RTN: 'ROUTINE',
  CC: 'CONTINUOUS_CARE',
  GIP: 'GENERAL_IN_PATIENT',
  RSP: 'RESPITE',
};

// {label: 'Routine Home Care', id: 'RTN', value: 'ROUTINE'}
export const lOCStatements: any = {
  RTN: '',
  CC: defaults.ccOrder,
  GIP: defaults.gipOrder,
  RSP: defaults.respiteOrder,
};

/**
WIDGET	      DATE TYPE		DATE-RESTRICTION	Confined to last IDG Confined to admit Confined to Other
							
ORDERS-ADMIT	  Verbal		  >= REFERRAL DATE				
	              Admit		    >= VERBAL DATE				
													
ORDERS-GENERAL	Verbal				                 x                   x 
	              Effective		>= VERBAL DATE		 		
							
ORDERS-LOC	    Verbal		  >= REFERRAL DATE				
	              Effective		>= VERBAL DATE		 x                                     > latest LOC	

FACILITY-ORDER  Verbal		  >= REFERRAL DATE			
	              Effective		>= VERBAL DATE	   x		                                 > latest Facility

ORDERS-DISCHARGE Verbal		  >= ADMIT DATE	     x	                 x	
	               Effective	>= VERBAL DATE			
 */
